module.exports = __webpack_public_path__ + "static/media/cft.ac610e93.png";